import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function B() {
    const { useLang, Link, useRouter, useState, useEffect } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('refurbished');
    const [gap, setGap] = useState(24);
    const items: any = [
        {
            img: '/responsive/picture/refurbished/2_1',
            title: t('secB_card1_title'),
            desc: t('secB_card1_text'),
        },
        {
            img: '/responsive/picture/refurbished/2_2',
            title: t('secB_card2_title'),
            desc: t('secB_card2_text'),
        },
        {
            img: '/responsive/picture/refurbished/2_3',
            title: t('secB_card3_title'),
            desc: t('secB_card3_text'),
        },
        {
            img: '/responsive/picture/refurbished/2_4',
            title: t('secB_card4_title'),
            desc: t('secB_card4_text'),
        },
    ];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW >= 1440) {
                    return setGap(24);
                } else if (winW > 1024) {
                    return setGap(20);
                } else {
                    return setGap(16);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => window.removeEventListener('resize', resetGap);
        }
    }, []);

    return (
        <div id="refurbished-B" className={`refurbished-B ${css['refurbished-B']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secB_title')}</p>
                    <p className="desc">{t('secB_desc')}</p>
                </div>
                <ul className="card-box">
                    {items?.map((item: any, k: number) => (
                        <li className="card-item" key={k}>
                            <EFPicture src={`${item?.img}.jpg`} srcDesktop={`${item?.img}_1366.jpg`} alt={item?.title} />
                            <div className="card-text">
                                <p className="card-title">{item?.title}</p>
                                <p className="card-desc">{item?.desc}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
